import styled from 'styled-components';

// Core imports
import { darkerBlackPearl, firefly } from '@paradigm/design-system/src/colors';
import { MOBILE_BREAKPOINT } from '#/containers/layout/constants';
import { AccountSelectContainer } from '#/components/account-selection/AccountSelect';

// Components
import { HIDDEN_LIMIT_QUOTE_BUILDER_FORM_ID } from '#/components/UnifiedRfqs/drfq/constants';
import { Divider } from '../common';
import AccountSelect from './AccountSelect';
import TwoWay from './TwoWay';
import EstimatedPriceModal from './EstimatedPriceModal';

/**
 * HiddenLimitQuoteBuilderForm - Renders the input form for submitting quotes
 * Note: Submit functionality is handled by the parent component
 */
export default function HiddenLimitQuoteBuilderForm({
  greeks,
  onSubmit,
}: {
  greeks: JSX.Element | null;
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
}) {
  const hasGreeks = greeks != null;
  const greeksDivider = hasGreeks && <Divider />;

  return (
    <QuoteBuilderForm
      id={HIDDEN_LIMIT_QUOTE_BUILDER_FORM_ID}
      onSubmit={onSubmit}
    >
      <TopSection>
        <AccountSelect />
        {greeks}
      </TopSection>
      {greeksDivider}
      <BottomSection>
        <TwoWay />
      </BottomSection>
      <EstimatedPriceModal />
    </QuoteBuilderForm>
  );
}

/**
 * Styled components
 */
const QuoteBuilderForm = styled.form`
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: ${firefly};
  border-radius: 0 0 10px 0;
`;

const TopSection = styled.div`
  flex: 0 0 auto;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  ${AccountSelectContainer} {
    margin-bottom: 0;
  }

  .strategy-greeks {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }
`;

const BottomSection = styled.div`
  flex: 1;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  margin-top: auto;

  ${Divider} {
    width: 100%;
    margin: 1rem 0;

    &:before {
      background: linear-gradient(
        359deg,
        rgba(54, 121, 221, 0) 0%,
        rgba(54, 121, 221, 1) 50%,
        rgba(54, 121, 221, 0) 100%
      );
    }
  }

  @media screen and (max-width: ${MOBILE_BREAKPOINT}px) {
    background-color: ${darkerBlackPearl};
    padding: 1rem;
    border-radius: 0.25rem;

    &&& button {
      font-size: 1rem;
      line-height: 2rem;
      height: auto;
      padding: 0;
      border-radius: 1rem;
    }

    label {
      font-size: 1rem;
      line-height: 2rem;
    }
  }
`;
